export const ActionType = {
  GetList: Symbol("GetHomebuyerList"),
  Create: Symbol("CreateHomebuyer"),
  Update: Symbol("UpdateHomebuyer"),
  UpdateStatus: Symbol("UpdateHomebuyerStatus"),
  Delete: Symbol("DeleteHomebuyer"),
};
